import { TEMA_ROUTE_IDS } from "./temaRouteConstants";

const SECTION_HUB_PAGE_LOADER = {
  load: () => import("../pages/SectionHubPage"),
  exportName: "SectionHubPage",
};

/** Dynamic import loaders shared by React.lazy and route prefetch. */
export const TEMA_PAGE_LOADERS = {
  [TEMA_ROUTE_IDS.DASHBOARD]: {
    load: () => import("../pages/DashboardPage"),
    exportName: "DashboardPage",
  },
  [TEMA_ROUTE_IDS.TEACH_PREPARE]: SECTION_HUB_PAGE_LOADER,
  [TEMA_ROUTE_IDS.CREATE_QUESTIONS]: SECTION_HUB_PAGE_LOADER,
  [TEMA_ROUTE_IDS.BUILD_ASSESSMENTS]: SECTION_HUB_PAGE_LOADER,
  [TEMA_ROUTE_IDS.ASSIGN_ENRICHMENT]: SECTION_HUB_PAGE_LOADER,
  [TEMA_ROUTE_IDS.QUICK_SHEETS]: {
    load: () => import("../pages/QuickSheetsPage"),
    exportName: "QuickSheetsPage",
  },
  [TEMA_ROUTE_IDS.CONCEPT_QUESTIONS]: {
    load: () => import("../pages/ConceptQuestionsPage"),
    exportName: "ConceptQuestionsPage",
  },
  [TEMA_ROUTE_IDS.QUESTION_VARIATIONS]: {
    load: () => import("../pages/QuestionVariationsPage"),
    exportName: "QuestionVariationsPage",
  },
  [TEMA_ROUTE_IDS.QUICK_ASSESSMENT]: {
    load: () => import("../pages/QuickAssessmentPage"),
    exportName: "QuickAssessmentPage",
  },
  [TEMA_ROUTE_IDS.TEACH_THIS_TOPIC]: {
    load: () => import("../pages/TeachThisTopicPage"),
    exportName: "TeachThisTopicPage",
  },
  [TEMA_ROUTE_IDS.EXPLAIN_DIFFERENTLY]: {
    load: () => import("../pages/ExplainDifferentlyPage"),
    exportName: "ExplainDifferentlyPage",
  },
  [TEMA_ROUTE_IDS.CONTENT_SIMPLIFIER]: {
    load: () => import("../pages/ContentSimplifierPage"),
    exportName: "ContentSimplifierPage",
  },
  [TEMA_ROUTE_IDS.QUESTION_PAPER]: {
    load: () => import("../pages/QuestionPaperPage"),
    exportName: "QuestionPaperPage",
  },
  [TEMA_ROUTE_IDS.SECTION_BUILDER]: {
    load: () => import("../pages/SectionBuilderPage"),
    exportName: "SectionBuilderPage",
  },
  [TEMA_ROUTE_IDS.DIFFICULTY_BALANCER]: {
    load: () => import("../pages/DifficultyBalancerPage"),
    exportName: "DifficultyBalancerPage",
  },
  [TEMA_ROUTE_IDS.DOUBT_SOLVER]: {
    load: () => import("../pages/DoubtSolverPage"),
    exportName: "DoubtSolverPage",
  },
  [TEMA_ROUTE_IDS.SLIDE_DECK_GENERATOR]: {
    load: () => import("../pages/SlideDeckGeneratorPage"),
    exportName: "SlideDeckGeneratorPage",
  },
  [TEMA_ROUTE_IDS.PROJECT_BUILDER]: {
    load: () => import("../pages/ProjectBuilderPage"),
    exportName: "ProjectBuilderPage",
  },
  [TEMA_ROUTE_IDS.ACTIVITY_GENERATOR]: {
    load: () => import("../pages/ActivityGeneratorPage"),
    exportName: "ActivityGeneratorPage",
  },
  [TEMA_ROUTE_IDS.REAL_WORLD_TASK]: {
    load: () => import("../pages/RealWorldTaskGeneratorPage"),
    exportName: "RealWorldTaskGeneratorPage",
  },
  [TEMA_ROUTE_IDS.LIBRARY]: {
    load: () => import("../pages/LibraryPage"),
    exportName: "LibraryPage",
  },
  [TEMA_ROUTE_IDS.BILLING]: {
    load: () => import("../pages/BillingPage"),
    exportName: "BillingPage",
  },
  [TEMA_ROUTE_IDS.CERTIFICATION]: {
    load: () => import("../pages/CertificationPage"),
    exportName: "CertificationPage",
  },
  [TEMA_ROUTE_IDS.AIFE_VERIFY]: {
    load: () => import("../pages/AifeVerifyPage"),
    exportName: "AifeVerifyPage",
  },
  [TEMA_ROUTE_IDS.ONBOARDING]: {
    load: () => import("../pages/TeacherOnboardingPage"),
    exportName: "TeacherOnboardingPage",
  },
};
